/**
 * Header component with project selector and user menu
 */

import React from 'react';
import { TenantSelector } from '../Workspace/TenantSelector';
import { ProjectSelector } from '../Workspace/ProjectSelector';
import { UserMenu } from './UserMenu';
import { HelpCenterButton } from '../HelpCenter';
import { NotificationButton } from '../Notifications/NotificationButton';
import { Menu } from 'lucide-react';

export interface HeaderProps {
  pluginActions?: React.ComponentType<any>[];
  defaultTenantId?: string;
  defaultProjectId?: string;
  sidebarCollapsed?: boolean;
  onToggleSidebar?: () => void;
  onNavigate?: (path: string) => void;
}

export function Header({ 
  pluginActions = [], 
  defaultTenantId, 
  defaultProjectId,
  sidebarCollapsed = false,
  onToggleSidebar,
  onNavigate
}: HeaderProps) {

  return (
    <header 
      className="sticky top-0 z-30 backdrop-blur-xl border-b shadow-sm h-16 flex items-center justify-between px-8"
      style={{
        backgroundColor: 'var(--color-header-bg, rgba(255, 255, 255, 0.9))',
        borderColor: 'var(--color-header-border, rgba(226, 232, 240, 0.6))',
        color: 'var(--color-header-text, #111827)'
      }}
    >
      {/* Left: Sidebar toggle and workspace selectors */}
      <div className="flex items-center gap-4">
        {onToggleSidebar && (
          <button
            onClick={onToggleSidebar}
            className="p-2 rounded-lg transition-colors"
            style={{
              color: 'var(--color-header-text, #374151)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--color-surface-hover, #f9fafb)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
            title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <Menu className="h-5 w-5" />
          </button>
        )}
        <TenantSelector defaultTenantId={defaultTenantId} />
        <ProjectSelector defaultProjectId={defaultProjectId} />
      </div>
      
      {/* Right: Actions and user */}
      <div className="flex items-center gap-4">
        {pluginActions.map((Action, idx) => (
          <Action key={idx} />
        ))}
        
        {/* Notification Button */}
        <NotificationButton />
        
        {/* Help Center Button */}
        <HelpCenterButton />
        
        {/* User menu */}
        <div 
          className="pl-4 border-l"
          style={{
            borderColor: 'var(--color-header-border, #e2e8f0)'
          }}
        >
          <UserMenu onNavigate={onNavigate} />
        </div>
      </div>
    </header>
  );
}

